// frontend/modules/account-settings/types/index.ts
export interface TransaccFormData {
    glNo: string;
    acNo: string;
    description: string;
    acctype: number;
}

export const ACCOUNT_TYPES = {
    CASH: 0,
    BANK: 1,
    TRANSFER: 2
} as const;